import { useCallback, useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { FinanceSummary, TransactionForm, TransactionsTable } from "@/components/app/finances/FinanceParts";

const empty = { type: "gelir", amount: 0, description: "", category: "", date: new Date().toISOString().slice(0, 10) };
const TABS = [["all", "Tümü"], ["gelir", "Gelir"], ["gider", "Gider"], ["tahsilat", "Tahsilat"]];

export default function Finances() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = useCallback(async () => {
    const { data } = await http.get("/transactions", { params: tab !== "all" ? { type: tab } : {} });
    setItems(data);
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await http.post("/transactions", { ...form, amount: parseFloat(form.amount) || 0 });
      toast.success("Kaydedildi");
      setOpen(false); setForm(empty); load();
    } catch { toast.error("Hata"); }
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await http.delete(`/transactions/${id}`); load();
  };

  const totals = items.reduce((acc, t) => ({ ...acc, [t.type]: (acc[t.type] || 0) + t.amount }), {});

  return (
    <div className="space-y-6" data-testid="finances-page">
      <FinanceSummary totals={totals} />
      <div className="flex flex-wrap items-center gap-3">
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList data-testid="tx-tabs">
            {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`tab-${v}`}>{l}</TabsTrigger>)}
          </TabsList>
        </Tabs>
        <div className="ml-auto">
          <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setForm(empty); }}>
            <DialogTrigger asChild>
              <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="add-transaction-button"><Plus className="h-4 w-4 mr-2" /> Yeni Kayıt</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Yeni Finansal Kayıt</DialogTitle></DialogHeader>
              <TransactionForm form={form} setForm={setForm} onSubmit={submit} />
            </DialogContent>
          </Dialog>
        </div>
      </div>
      <TransactionsTable items={items} onDelete={del} />
    </div>
  );
}
